import { validationMixin } from 'vuelidate'
import { get, isUndefined } from 'lodash-es'

import FormErrorMixin from '@/js/components/Forms/mixins/form-error-mixin'

export default {
  mixins: [validationMixin, FormErrorMixin],
  computed: {
    isValid() {
      return !this.$v.$error
    },
  },
  methods: {
    touch(name) {
      get(this.$v, name).$touch()
    },
    validate() {
      this.$v.$reset()
      this.$v.$touch()
    },
    resetValidation() {
      this.$v.$reset()
    },
    resetFieldValidation(name) {
      get(this.$v, name).$reset()
    },
    submit() {
      this.validate()

      if (this.isValid && !isUndefined(this.submitCallback)) {
        this.$nextTick(() => this.submitCallback())
      }
    },
    getTouchListeners(name, index = -1) {
      if (name) {
        let touchFunc = () => this.touch(name)

        if (index > -1) {
          touchFunc = () => get(this.$v, `${name}.$each.$iter.${index}.$touch`, () => undefined)()
        }

        return {
          input: touchFunc,
          blur: touchFunc,
        }
      }
    },
  },
}
